<template>
  <div>
    <el-form
      v-if="activeName === '待采购'"
      class="search-style-plan"
      :style="{'height':showAll?'auto':'80px','paddingBottom':showAll?'0':'20px'}"
      label-width="70px"
      label-position="left"
    >
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="工单编号：">
            <el-input clearable v-model.trim="params.ocspCode" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="备货方式：">
            <el-select clearable v-model.trim="params.stockupType">
              <el-option label="直发备货" value="直发备货"></el-option>
              <el-option label="入库备货" value="入库备货"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="备货仓库：">
            <el-select filterable v-model.trim="params.sbId" clearable placeholder="请选择">
              <el-option
                v-for="(item,index) in houseSelect"
                :key="index"
                :label="item.storageName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item clearable label="询价供应商：" label-width="90px">
            <el-input v-model.trim="params.suName" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="货期：" clearable label-width="50px">
            <el-input style="width:90%;" v-model.trim="params.cbExTime" placeholder="请输入关键词"></el-input>
            {{'天'}}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="预计发货时间：" clearable label-width="100px">
            <el-date-picker
              v-model.trim="time"
              style="width:100%;"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="品牌：" clearable label-width="50px">
            <el-select filterable v-model.trim="params.bbId">
              <el-option
                v-for="(item, index) in brandList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <div></div>
        <el-col :span="6" v-show="showAll">
          <el-form-item label="型号：" clearable label-width="50px">
            <el-input v-model.trim="params.proModel" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-show="showAll">
          <el-form-item label="订货号：" clearable label-width="60px">
            <el-input v-model.trim="params.proOrdernum" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
         <el-col :span="6" v-show="showAll">
          <el-form-item label="发起人：" clearable label-width="60px">
            <el-input v-model.trim="params.createUser" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="showAll? 12 : 6" style="text-align:right;">
          <el-form-item label-width="0" min-width="100px;">
            <el-button @click="searchFor" type="primary">搜索</el-button>
            <el-button @click="searchReset" type>重置</el-button>
            <el-button type="text" style="margin-left:10px" @click="closeSearch">
              {{word}}
              <i :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"></i>
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20"></el-row>
    </el-form>
    <el-form
      v-else
      class="search-style-plan"
      :style="{'height':showAll?'auto':'80px','paddingBottom':showAll?'0':'20px'}"
      label-width="70px"
      label-position="left"
    >
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="合同编号：">
            <el-input clearable v-model.trim="params.pcbNumber" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="供应商合同编号：" label-width="120px">
            <el-input clearable v-model.trim="params.supplierContractNumber" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-show="activeName ==='采购中'||activeName ==='已采购'">
          <el-form-item label="签订时间：" clearable label-width="70px">
            <el-date-picker
              v-model.trim="time"
              style="width:100%;"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="供应商名称：" label-width="90px">
            <el-input clearable v-model.trim="params.suName" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="工单编号：">
            <el-input clearable v-model.trim="params.ocspCode" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="备货方式：">
            <el-select clearable v-model.trim="params.stockupType">
              <el-option label="直发备货" value="直发备货"></el-option>
              <el-option label="入库备货" value="入库备货"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="备货仓库：">
            <el-select filterable v-model.trim="params.sbId" clearable placeholder="请选择">
              <el-option
                v-for="(item,index) in houseSelect"
                :key="index"
                :label="item.storageName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6" v-show="activeName ==='已采购'&&showAll||activeName ==='采购中'&&showAll">
          <el-form-item label="发货状态：" clearable label-width="70px">
            <el-select clearable v-model.trim="params.deliverState">
              <el-option v-show="activeName ==='采购中'" label="待发货" value="待发货"></el-option>
              <el-option v-show="activeName ==='采购中'" label="物流在途" value="物流在途"></el-option>
              <el-option v-show="activeName ==='已采购'" label="已入库" value="已入库"></el-option>
              <el-option v-show="activeName ==='已采购'" label="已发货" value="已发货"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-show="activeName ==='采购中'&&showAll||activeName ==='已采购'&&showAll">
          <el-form-item label="类型：" label-width="50px">
            <el-select clearable v-model.trim="params.proExtype">
              <el-option label="现货" value="现货"></el-option>
              <el-option label="期货" value="期货"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          :span="6"
          v-show="activeName ==='采购中'&&showAll||activeName ==='采购审核'||activeName ==='已采购'&&showAll"
        >
          <el-form-item label="货期：" clearable label-width="50px">
            <el-input style="width:90%;" v-model.trim="params.cbExTime" placeholder="请输入关键词"></el-input>
            {{'天'}}
          </el-form-item>
        </el-col>
        <el-col :span="6" v-show="showAll">
          <el-form-item label="品牌：" clearable label-width="50px">
            <el-select filterable v-model.trim="params.bbId">
              <el-option
                v-for="(item, index) in brandList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-show="showAll">
          <el-form-item label="型号：" clearable label-width="50px">
            <el-input v-model.trim="params.proModel" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-show="showAll">
          <el-form-item label="订货号：" clearable label-width="60px">
            <el-input v-model.trim="params.proOrdernum" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col v-show="activeName ==='采购审核'" :span="showAll? 12 : 6" style="text-align:right;">
          <el-form-item label-width="0" min-width="100px;">
            <el-button @click="searchFor" type="primary">搜索</el-button>
            <el-button @click="searchReset" type>重置</el-button>
            <el-button type="text" style="margin-left:10px" @click="closeSearch">
              {{word}}
              <i :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"></i>
            </el-button>
          </el-form-item>
        </el-col>
        <el-col
          v-show="activeName ==='采购中'||activeName ==='已采购'"
          :span="showAll? 18 : 6"
          style="text-align:right;"
        >
          <el-form-item label-width="0" min-width="100px;">
            <el-button @click="searchFor" type="primary">搜索</el-button>
            <el-button @click="searchReset" type>重置</el-button>
            <el-button type="text" style="margin-left:10px" @click="closeSearch">
              {{word}}
              <i :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"></i>
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import {
  houseInformation
} from '@/api/storage/storage'
export default {
  props: ['activeName'],
  components: {
  },
  watch: {
    activeName: {
      handler (newVal) {
        this.showAll = false
        this.params = {}
        this.time = []
      }
    }
  },
  computed: {
    word: function () {
      if (this.showAll === false) {
        // 对文字进行处理
        return '展开'
      } else {
        return '收起'
      }
    }
  },

  data () {
    return {
      showAll: true, // 是否展开全部
      waitFeedbackEnquiryList: [],
      params: {},
      time: [],
      queryParams: {},
      houseSelect: [],
      brandList: []
    }
  },
  mounted () {
    this.gethouseList()
    this.getBrandForSelect()
    this.$nextTick(function () {
      this.closeSearch()
    })
  },
  methods: {
    closeSearch () {
      this.showAll = !this.showAll
      this.$emit('showAllList', this.showAll)
    },
    // 获取仓库信息
    gethouseList () {
      houseInformation().then((res) => {
        if (res.data.code === 200) {
          this.houseSelect = res.data.obj
        }
      })
    },
    searchColumn () {
    },
    searchReset () {
      this.params = {}
      this.time = []
      this.$emit('searchReset', this.params)
    },
    searchFor () {
      for (const key in this.params) {
        if (this.params[key] === undefined || this.params[key] === '') {
          delete this.params[key]
        }
      }
      if (this.time && this.time.length === 2) {
        this.$emit('searchFor', this.params, this.time[0], this.time[1])
      } else {
        this.$emit('searchFor', this.params)
      }
    },
    handleSelectionChange () {

    },
    // 获取所有品牌名称
    async getBrandForSelect () {
      this.brandList = await this.$queryAllBrandForSelect()
    },
    // 翻页
    handleSizeChange (val) {
      this.pageSize = val
      // this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      // this.getList()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style lang="scss" scoped>
.item-box-content-bottom {
  background-color: #fff;
  margin-bottom: 20px;
  padding: 20px 20px 0 20px;
  font-size: 14px;
  border-radius: 4px;

  .config-instruction {
    padding: 10px 0px 10px 20px;
  }
}
</style>
